import * as ConferenceService from '../../service/ConferenceService'
import * as types from '../mutation-types'
import mutation from '../mutation'
const state = {
	sceneCommentList: [],
	conferenceknowledgeList: [],
	pageNo: 1,
	knowledgePage: 1
}
const getters = {
	sceneCommentList: () => state.sceneCommentList,
	conferenceknowledgeList: () => state.conferenceknowledgeList
}
const mutations = {
	[types.GET_CONFERENCE_COMMENT_LIST](state, {
		commentList,
		list
	}) {
		state.sceneCommentList = [...commentList, ...list]
	},
	[types.GET_CONFERENCE_KNOWLEDGE_LIST](state, {
		knowledgeList,
		knowledgePage,
		list
	}) {
		state.conferenceknowledgeList = [...knowledgeList, ...list]
		state.knowledgePage = ++knowledgePage
	},
	[types.ADD_CONFERENCE_COMMENT](state, comment) {
		state.sceneCommentList = [comment, ...state.sceneCommentList]
	},
	[types.UPDATE_CONFERENCE_COMMENT](state, item) {
		let newList = state.sceneCommentList.map(comment => {
			if (item.commentId === comment.commentId) {
				comment = item
			}
			return comment
		})
		state.sceneCommentList = newList
	},
	[types.ADD_CONFERENCE_COMMENT_REPLY](state, item) {
		let newList = state.sceneCommentList.map(comment => {
			if (item.commentId === comment.commentId) {
				let childComments = comment.childComments || []
				comment = { ...comment,
					replyCount: comment.replyCount + 1,
					childComments: [...childComments,item.childComment]
				}
			}
			return comment
		})
		state.sceneCommentList = newList
	},
}
const actions = {
	initSceneCommentList({
		commit,
		state
	},req) {
		return ConferenceService.getSceneCommentList(req)
			.then(res => {
				commit(types.GET_CONFERENCE_COMMENT_LIST, {
					commentList: [],
					list: res.data
				})
				return Promise.resolve(res.data)
			}, rea => {
				return Promise.reject(rea)
			})
	},
	getSceneCommentList({
		commit,
		state
	},req) {
		return ConferenceService.getSceneCommentList(req)
			.then(res => {
				commit(types.GET_CONFERENCE_COMMENT_LIST, {
					commentList: state.sceneCommentList,
					list: res.data
				})
				return Promise.resolve(res.data)
			}, rea => {
				return Promise.reject(rea)
			})
	},
	initConferenceKnowledgeList({
		commit,
		state
	}, meetingId) {
		commit(types.REQUEST_DOING)
		return ConferenceService.getConferenceKnowledgeList(meetingId, 1)
			.then(res => {
				commit(types.GET_CONFERENCE_KNOWLEDGE_LIST, {
					knowledgeList: [],
					knowledgePage: 1,
					list: res
				})
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			}, rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			})
	},
	getConferenceKnowledgeList({
		commit,
		state
	}, meetingId) {
		commit(types.REQUEST_DOING)
		return ConferenceService.getConferenceKnowledgeList(meetingId, state.knowledgePage)
			.then(res => {
				commit(types.GET_CONFERENCE_KNOWLEDGE_LIST, {
					knowledgeList: state.conferenceknowledgeList,
					knowledgePage: state.knowledgePage,
					list: res
				})
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			}, rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			})
	},
	onSubmitComment({
		commit,
		state
	}, req) {
		return ConferenceService.onSubmitComment(req)
			.then(res => {
				commit(types.ADD_CONFERENCE_COMMENT, res.data)
				return Promise.resolve(res.data)
			}, rea => {
				return Promise.reject(rea)
			})
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
